export const KEYS = {
  token: 'user-token'
}
